<template>
  <Modal :id="'cmp-settings-money-details-form'" @cancelled="onCancel" :loadingFlag="loadingFlag">
    <template slot="header">{{title}} {{$t('product_type_string')}}</template>
    <template slot="body">
      <div class="form-group">
        <TextField
          class="m1"
          :id="'product_type_name'"
          v-bind="textFieldConfig"
          required
          :showValidationIcons="true"
          :immediateValidation="true"
          :value="product_type.product_type_name"
          :placeholder="$t('name')"
          @valuechanged="onTextFieldValueChange"
          @validated="(e, vr) => onValidationDone('product_type_name', vr)"
        ></TextField>
        <div class="dt-checkbox-control">
          <div class="dt-checkbox v2 s1">
            <input
              type="checkbox"
              :name="'valuelist'"
              :id="'valuelist'"
              :checked="product_type.valuelist=='2'"
              @click="e => onCheckboxChange('valuelist', e)"
            />
            <div class="checkmark"></div>
          </div>
          <div class="dt-checkbox-label">{{$t('2nd')}}</div>
        </div>
      </div>
    </template>
    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">{{$t('cancel')}}</button>
      <button 
        @click.stop="onFormSubmit"
        class="dt-button v1 s6"
        :class="{
          'disabled': !isFormValid(),
        }" 
        :disabled="!isFormValid()"
      >{{$t('ok')}}</button>
    </template>
  </Modal>
</template>

<script>
import Modal from "@dtplugins/modal/modal";
import { createFormModalMixin, createFormItemMixin } from "../../../../dt-plugins/form-modal/form-modal";
import { LabelSettingsService } from "../../services/label-settings.service";
import { getVatTypes } from "../../models/invoice-line.model";
import { createTextFieldConfig } from '../../../../plugins/text-field';

export default {
  components: {
    Modal
  },
  props: {},
  mixins: [
    createFormModalMixin(),
    createFormItemMixin({
      primary_key: "product_type_id",
      itemKey: "product_type",
      detailsHttpReq: LabelSettingsService.findProductTypeDetails
    })
  ],
  data: function() {
    return {
      vatT_types: getVatTypes(),

      textFieldConfig: createTextFieldConfig({
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,
      }),

      formValidation: {},
    };
  },
  methods: {
    get_product_type: function() {
      return {
        product_type_id: "",
        value: "",
        valuelist: "",
        product_type_name: "",
        product_type_name2: null,
        label: ""
      };
    },
    onCheckboxChange: function(name, event) {
      const value = event.target.checked ? '2' : '1';
      this.product_type[name] = value;
    },
    onValidationDone: function(id, validationResult) {
      this.formValidation = {
        ...this.formValidation,
        [id]: validationResult
      };
    },
    isFormValid: function() {
      return Object.keys(this.formValidation).map(key => this.formValidation[key].valid).every(e => e);
    }
    //MARK: Methods
  }
};
</script>

<style lang="scss">
.cmp-settings-money-details-form {
  .dt-checkbox-control {
    display: flex;
    padding-top: 12px;
    // margin-left: 0px;
    .dt-checkbox {
      max-width: 40px;
      margin: 3px 10px 0px 0px;
    }
  }
}
</style>
